module.exports = __webpack_public_path__ + "static/media/142bf7fe2b88ca521d02397f88943325_html_60d03fc39e4f2ccc.8f4984a0.png";